import React from "react";
import { useTranslation } from "react-i18next";
import { useWorkflow } from "../../workflow/WorkflowContext";
import { CalculatePanel } from "../../components/CalculatePanel";
import { LockedCalcNote, StaleInputsNote } from "../../components/LockedCalcNote";

/** Step 2 — Configure (period + seller registrations). v0.6 nav refactor:
 *  dedicated route component (migrated out of the Phase-1 shim). */
export default function Step2Configure() {
  const { setActiveStep, state, calc } = useWorkflow();
  const { t } = useTranslation();
  const blocked = !state.steps[2].complete;
  return (
    <section data-testid="step-2-configure" className="space-y-3">
      <LockedCalcNote calc={calc} step={2} />
      <StaleInputsNote calc={calc} derived={state.derived} step={2} />
      <CalculatePanel />
      <button type="button" data-testid="step-2-continue"
        disabled={blocked} title={blocked ? state.steps[2].blockers[0] : ""}
        onClick={() => setActiveStep(3)}
        className="bg-teal-600 hover:bg-teal-700 disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold px-4 py-2 tabular-nums text-xs rounded-xl">
        {t("ui.dashboard.continue_to_step", { idx: 3, label: t("ui.stepper.step3") })}
      </button>
    </section>
  );
}
